module.exports = __webpack_public_path__ + "img/second-block-bg.602fa2f3.jpg";